export default class SingleProjectDetailed {
	constructor() {
		this.nav = document.querySelector('.project-nav-wrapper');
		this.links = document.querySelectorAll('.navs-project .menu-item-lev1 a');
		this.sections = [];
		
		if (!this.nav) return;
		
		this.init();
	}

	init() {
		// Récupérer toutes les sections avec des IDs
		this.links.forEach(link => {
			const targetId = link.getAttribute('href').substring(1);
			const section = document.getElementById(targetId);
			if (section) {
				this.sections.push({
					id: targetId,
					element: section,
					link: link,
					menuItem: link.closest('.menu-item-lev1')
				});
			}
		});

		// Gestion du scroll
		window.addEventListener('scroll', () => this.onScroll(), { passive: true });
		
		// Smooth scroll au clic
		this.links.forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const targetId = link.getAttribute('href').substring(1);
				const target = document.getElementById(targetId);
				
				if (target) {
					const navHeight = this.nav.offsetHeight;
					const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - navHeight - 20;
					
					window.scrollTo({
						top: targetPosition,
						behavior: 'smooth'
					});
				}
			});
		});
	}

	onScroll() {
		const scrollPosition = window.scrollY + this.nav.offsetHeight + 100;
		
		// Trouver la section active
		let currentSection = null;
		
		this.sections.forEach(section => {
			const sectionTop = section.element.offsetTop;
			const sectionBottom = sectionTop + section.element.offsetHeight;
			
			if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
				currentSection = section;
			}
		});
		
		// Mettre à jour les liens actifs
		this.sections.forEach(section => {
			if (section.menuItem) {
				section.menuItem.classList.remove('active');
			}
		});
		
		if (currentSection && currentSection.menuItem) {
			currentSection.menuItem.classList.add('active');
		}
	}
}
